<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Update Seat Information</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="modalClose()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">Update seat information for Table {{table.tableNum}} - {{table.tableCategory === "" ? "" : table.tableCategory}} </div>
        </div>
    </div>
</div>

<div class="modal-body custom-material-form">

    <div class="row justify-content-center">
        <div class="col">
            <div class="table--paybee">
                <form [formGroup]="seatForm">
                    <table class="table">
                        <thead class="thead-light">
                            <tr>
                                <th>Seat Number</th>
                                <th>Seat Name (optional)</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let seat of table.seats;">
                                <th>{{seat.seatNum}}</th>
                                <th>
                                    <div class="md-form">
                                        <input mdbInput 
                                        [formControlName]="seat.seatNum"
                                        maxlength="128"
                                        type="text" 
                                        id="seatName" 
                                        class="form-control validate mb-0">
                                        <label mdbLabel [ngClass]="{'active': seat.seatNum !== ''}" class="inputLabel" for="seatName">Seat Name</label>
                                    </div>
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer paybee-modal-footer">
    <a class="btn btn-sm modal-cancel-button waves-effect waves-light" (click)="modalClose()">Cancel</a>
    <a class="btn btn-sm modal-confirm-button waves-effect waves-light" (click)="update()">Update</a>
</div>